"use client";

import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";
import { ApiPage } from "@/api/page";

export const useReturnInfoData = () => {
  const { data, isLoading } = useLocalizedQuery({
    queryKey: ["return-info"],
    queryFn: async lang => ApiPage.getReturnInfoPage(lang),
  });

  return { data, isLoading };
};
